import { FIELD_TYPE } from "types/enums";
import React from "react";
import { ColumnProps } from "types/models";
import { formatToCurrencyType } from "helper/common";
import { DataFormField } from "types/models/input-field-type";
import moment from "moment";
import dayjs from "dayjs";
const { SELECT, DATE ,COMBO_BOX} = FIELD_TYPE;
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = currentYear - 20;
const endYear = currentYear + 5;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const field: DataFormField[] = [
  {
    type: SELECT,
    label: "Mẫu XML",
    name: "type",
    options: [
      { value: 1, label: "Báo cáo tổng hợp vật tư y tế" },
      { value: 2, label: "Báo cáo tổng hợp thuốc" },
      { value: 3, label: "Báo cáo tổng hợp DVKT" },
      { value: 4, label: "Biểu mẫu 7980a" },
      { value: 5, label: "Biểu mẫu 19" },
      { value: 6, label: "Biểu mẫu 20" },
      { value: 7, label: "Biểu mẫu 21" },
      { value: 8, label: "Biểu mẫu C79" },
      { value: 999, label: "Biểu mẫu C80" },
    ],
    rules: [{ required: true, message: "Chưa chọn mẫu XML" }],
  },
  {
    type: DATE,
    label: "Từ ngày",
    name: "ngayBatDau",
    rules: [{ required: true, message: "Chưa chọn ngày bắt đầu" }],
  },
  {
    type: DATE,
    label: "Đến ngày",
    name: "ngayKetThuc",
    rules: [{ required: true, message: "Chưa chọn ngày kết thúc" }],
  },
];

const field2: DataFormField[] = [
  {
    type: SELECT,
    label: "Mẫu XML",
    name: "type",
    options: [
      { value: 1, label: "Báo cáo tổng hợp vật tư y tế" },
      { value: 2, label: "Báo cáo tổng hợp thuốc" },
      { value: 3, label: "Báo cáo tổng hợp DVKT" },
      { value: 4, label: "Biểu mẫu 7980a" },
      { value: 5, label: "Biểu mẫu 19" },
      { value: 6, label: "Biểu mẫu 20" },
      { value: 7, label: "Biểu mẫu 21" },
      { value: 8, label: "Biểu mẫu C79" },
      { value: 999, label: "Biểu mẫu C80" },
    ],
    rules: [{ required: true, message: "Chưa chọn mẫu XML" }],
  },
  {
    type: SELECT,
    label: "Tháng",
    name: "thang",
    rules: [{ required: true, message: "Chưa chọn tháng" }],
    options: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((el) => ({
      value: el,
      label: `Tháng ${el}`,
    })),
  },
  {
    type: COMBO_BOX,
    label: "Năm",
    name: "nam",
    options:listYears,
    rules: [{ required: true, message: "Chưa chọn năm" }],
  },
];

const columns1: ColumnProps[] = [
  {
    title: "STT",
    isResizable: true,
    dataIndex: "stt",
    key: "stt",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    width: "3%",
    align: "center",
    // fixed: "left"
  },
  {
    title: "Mã VTYT",
    isResizable: true,
    dataIndex: "ma_VTYT",
    key: "ma_VTYT",
    show: true,
    align: "center",
  },
  {
    title: "Tên VTYT",
    isResizable: true,
    dataIndex: "ten_VTYT",
    key: "ten_VTYT",
    show: true,
    align: "left",
  },
  {
    title: "Tên thương mại",
    isResizable: true,
    dataIndex: "ten_THUONG_MAI",
    key: "ten_THUONG_MAI",
    show: true,
    align: "left",
  },
  {
    title: "Quy cách",
    isResizable: true,
    dataIndex: "quy_CACH",
    key: "quy_CACH",
    show: true,
    align: "left",
  },
  {
    title: "Đơn vị",
    isResizable: true,
    dataIndex: "don_VI",
    key: "don_VI",
    show: true,
    align: "center",
  },
  {
    title: "Giá mua",
    isResizable: true,
    dataIndex: "gia_MUA",
    key: "gia_MUA",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "SL nội trú",
    isResizable: true,
    dataIndex: "sl_NOI_TRU",
    key: "sl_NOI_TRU",
    show: true,
    align: "right",
  },
  {
    title: "SL ngoại trú",
    isResizable: true,
    dataIndex: "sl_NGOAI_TRU",
    key: "sl_NGOAI_TRU",
    show: true,
    align: "right",
  },
  {
    title: "Giá thanh toán",
    isResizable: true,
    dataIndex: "gia_THANHTOAN",
    key: "gia_THANHTOAN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thành tiền",
    isResizable: true,
    dataIndex: "thanh_TIEN",
    key: "thanh_TIEN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
];

const columns2: ColumnProps[] = [
  {
    title: "STT",
    isResizable: true,
    dataIndex: "stt",
    key: "stt",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    width: "3%",
    align: "center",
    // fixed: "left"
  },
  {
    title: "Mã thuốc",
    isResizable: true,
    dataIndex: "ma_THUOC",
    key: "ma_THUOC",
    show: true,
    align: "center",
  },
  {
    title: "Tên hoạt chất",
    isResizable: true,
    dataIndex: "ten_HOATCHAT",
    key: "ten_HOATCHAT",
    show: true,
    align: "left",
  },
  {
    title: "Tên thuốc",
    isResizable: true,
    dataIndex: "ten_THUOC",
    key: "ten_THUOC",
    show: true,
    align: "left",
  },
  {
    title: "Đường dùng",
    isResizable: true,
    dataIndex: "duong_DUNG",
    key: "duong_DUNG",
    show: true,
    align: "left",
  },
  {
    title: "Hàm lượng",
    isResizable: true,
    dataIndex: "ham_LUONG",
    key: "ham_LUONG",
    show: true,
    align: "center",
  },
  {
    title: "Số đăng kí",
    isResizable: true,
    dataIndex: "so_DKY",
    key: "so_DKY",
    show: true,
    align: "center",
    // render : (value, record, index) => {
    //   return <>{formatToCurrencyType(value)}</>
    // }
  },
  {
    title: "Đơn vị",
    isResizable: true,
    dataIndex: "don_VI",
    key: "don_VI",
    show: true,
    align: "center",
  },
  {
    title: "SL nội trú",
    isResizable: true,
    dataIndex: "sl_NOI_TRU",
    key: "sl_NOI_TRU",
    show: true,
    align: "center",
  },
  {
    title: "SL ngoại trú",
    isResizable: true,
    dataIndex: "sl_NGOAI_TRU",
    key: "sl_NGOAI_TRU",
    show: true,
    align: "center",
  },
  {
    title: "Đơn giá",
    isResizable: true,
    dataIndex: "gia_THANHTOAN",
    key: "gia_THANHTOAN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thành tiền",
    isResizable: true,
    dataIndex: "thanh_TIEN",
    key: "thanh_TIEN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
];

const columns3: ColumnProps[] = [
  {
    title: "STT",
    isResizable: true,
    dataIndex: "stt",
    key: "stt",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    width: "3%",
    align: "center",
    // fixed: "left"
  },
  {
    title: "Mã DVKT",
    isResizable: true,
    dataIndex: "ma_DVKT",
    key: "ma_DVKT",
    show: true,
    align: "center",
  },
  {
    title: "Tên DVKT",
    isResizable: true,
    dataIndex: "ten_DVKT",
    key: "ten_DVKT",
    show: true,
    align: "left",
  },
  {
    title: "SL nội trú",
    isResizable: true,
    dataIndex: "sl_NOITRU",
    key: "sl_NOITRU",
    show: true,
    align: "right",
  },
  {
    title: "SL ngoại trú",
    isResizable: true,
    dataIndex: "sl_NGOAITRU",
    key: "sl_NGOAITRU",
    show: true,
    align: "right",
  },
  {
    title: "Đơn giá",
    isResizable: true,
    dataIndex: "don_GIA",
    key: "don_GIA",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thành tiền",
    isResizable: true,
    dataIndex: "thanh_TIEN",
    key: "thanh_TIEN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
];

const columns4: ColumnProps[] = [
  {
    title: "STT",
    isResizable: true,
    dataIndex: "stt",
    key: "stt",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    width: "40px",
    align: "center",
    // fixed: "left"
  },
  {
    title: "Mã BN",
    isResizable: true,
    dataIndex: "ma_BN",
    key: "ma_BN",
    show: true,
    align: "center",
  },
  {
    title: "Họ tên BN",
    isResizable: true,
    dataIndex: "ho_TEN",
    key: "ho_TEN",
    show: true,
    align: "left",
  },
  {
    title: "Ngày sinh",
    isResizable: true,
    dataIndex: "ngay_SINH",
    key: "ngay_SINH",
    show: true,
    align: "center",
    render: (value, record, index) => {
      return dayjs(value).format("DD/MM/YYYY");
    },
  },
  {
    title: "Giới tính",
    isResizable: true,
    dataIndex: "gioi_TINH",
    key: "gioi_TINH",
    show: true,
    align: "center",
    render: (gioi_TINH) => {
      if (gioi_TINH == "1") {
        return "Nam";
      } else if (gioi_TINH == "2") {
        return "Nữ";
      }
    },
  },
  {
    title: "Địa chỉ",
    isResizable: true,
    dataIndex: "dia_CHI",
    key: "dia_CHI",
    show: true,
    align: "left",
  },
  {
    title: "Mã thẻ",
    isResizable: true,
    dataIndex: "ma_THE",
    key: "ma_THE",
    show: true,
    align: "center",
    // render : (value, record, index) => {
    //   return <>{formatToCurrencyType(value)}</>
    // }
  },
  {
    title: "Mã DKBD",
    isResizable: true,
    dataIndex: "ma_DKBD",
    key: "ma_DKBD",
    show: true,
    align: "center",
  },
  {
    title: "Giá trị thẻ từ",
    isResizable: true,
    dataIndex: "gt_THE_TU",
    key: "gt_THE_TU",
    show: true,
    align: "center",
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY");
      } else {
        return value; // hoặc bạn có thể trả về một chuỗi rỗng hoặc giá trị khác tùy thuộc vào trường hợp sử dụng của bạn
      }
    },
  },
  {
    title: "Giá trị thẻ đến",
    isResizable: true,
    dataIndex: "gt_THE_DEN",
    key: "gt_THE_DEN",
    show: true,
    align: "center",
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY");
      } else {
        return value; // hoặc bạn có thể trả về một chuỗi rỗng hoặc giá trị khác tùy thuộc vào trường hợp sử dụng của bạn
      }
    },
  },
  {
    title: "Mã bệnh",
    isResizable: true,
    dataIndex: "ma_BENH",
    key: "ma_BENH",
    show: true,
    align: "center",
  },
  {
    title: "Mã bệnh khác",
    isResizable: true,
    dataIndex: "ma_BENHKHAC",
    key: "ma_BENHKHAC",
    show: true,
    align: "center",
  },
  {
    title: "Lý do vào viện",
    isResizable: true,
    dataIndex: "ma_LYDO_VVIEN",
    key: "ma_LYDO_VVIEN",
    show: true,
    align: "left",
    render: (value, record, index) => {
      if (value === "1") {
        return "Đúng tuyến";
      } else if (value === "2") {
        return "Cấp cứu";
      } else if (value === "3") {
        return "Trái tuyến";
      } else if (value === "4") {
        return "Thông tuyến";
      } else {
        return value;
      }
    },
  },
  {
    title: "Mã nơi chuyển",
    isResizable: true,
    dataIndex: "ma_NOI_CHUYEN",
    key: "ma_NOI_CHUYEN",
    show: true,
    align: "center",
  },
  {
    title: "Ngày vào",
    isResizable: true,
    dataIndex: "ngay_VAO",
    key: "ngay_VAO",
    show: true,
    align: "center",
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY HH:mm");
      } else {
        return value; // hoặc bạn có thể trả về một chuỗi rỗng hoặc giá trị khác tùy thuộc vào trường hợp sử dụng của bạn
      }
    },
  },
  {
    title: "Ngày ra",
    isResizable: true,
    dataIndex: "ngay_RA",
    key: "ngay_RA",
    show: true,
    align: "center",
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY HH:mm");
      } else {
        return value; // hoặc bạn có thể trả về một chuỗi rỗng hoặc giá trị khác tùy thuộc vào trường hợp sử dụng của bạn
      }
    },
  },
  {
    title: "Số ngày điều trị",
    isResizable: true,
    dataIndex: "so_NGAY_DTRI",
    key: "so_NGAY_DTRI",
    show: true,
    align: "center",
  },
  {
    title: "Kết quả điều trị",
    isResizable: true,
    dataIndex: "ket_QUA_DTRI",
    key: "ket_QUA_DTRI",
    show: true,
    align: "left",
    render: (value, record, index) => {
      if (value === 1) {
        return "Khỏi";
      } else if (value === 2) {
        return "Đỡ";
      } else if (value === 3) {
        return "Không thay đổi";
      } else if (value === 4) {
        return "Nặng hơn";
      } else if (value === 5) {
        return "Tử vong";
      } else {
        return value;
      }
    },
  },
  {
    title: "Tình trạng ra viện",
    isResizable: true,
    dataIndex: "tinh_TRANG_RV",
    key: "tinh_TRANG_RV",
    show: true,
    align: "left",
    render: (value, record, index) => {
      if (value === 1) {
        return "Ra viện";
      } else if (value === 2) {
        return "Chuyển viện";
      } else if (value === 3) {
        return "Trốn viện";
      } else if (value === 4) {
        return "Xin ra viện";
      } else {
        return value;
      }
    },
  },
  {
    title: "Tổng chi phí",
    isResizable: true,
    dataIndex: "t_TONGCHI",
    key: "t_TONGCHI",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BH XN",
    isResizable: true,
    dataIndex: "t_XN",
    key: "t_XN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BH CĐHA",
    isResizable: true,
    dataIndex: "t_CDHA",
    key: "t_CDHA",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BH thuốc",
    isResizable: true,
    dataIndex: "t_THUOC",
    key: "t_THUOC",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BH máu",
    isResizable: true,
    dataIndex: "t_MAU",
    key: "t_MAU",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền NBHTT ",
    isResizable: true,
    dataIndex: "t_NBHTT",
    key: "t_NBHTT",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BH PTTT",
    isResizable: true,
    dataIndex: "t_PTTT",
    key: "t_PTTT",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BH VTYT",
    isResizable: true,
    dataIndex: "t_VTYT",
    key: "t_VTYT",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền DVKT tỉ lệ",
    isResizable: true,
    dataIndex: "t_DVKT_TYLE",
    key: "t_DVKT_TYLE",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BH thuốc tỉ lệ",
    isResizable: true,
    dataIndex: "t_THUOC_TYLE",
    key: "t_THUOC_TYLE",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền VTYT tỉ lệ",
    isResizable: true,
    dataIndex: "t_VTYT_TYLE",
    key: "t_VTYT_TYLE",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BHDV khám",
    isResizable: true,
    dataIndex: "t_KHAM",
    key: "t_KHAM",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BHDV giường",
    isResizable: true,
    dataIndex: "t_GIUONG",
    key: "t_GIUONG",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BHDV vận chuyển",
    isResizable: true,
    dataIndex: "t_VCHUYEN",
    key: "t_VCHUYEN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền thanh toán",
    isResizable: true,
    dataIndex: "t_THANHTOAN",
    key: "t_THANHTOAN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BNT",
    isResizable: true,
    dataIndex: "t_BNT",
    key: "t_BNT",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BHTT",
    isResizable: true,
    dataIndex: "t_BHTT",
    key: "t_BHTT",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền BNCT",
    isResizable: true,
    dataIndex: "t_BNCT",
    key: "t_BNCT",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Tổng tiền",
    isResizable: true,
    dataIndex: "t_TONGCONG",
    key: "t_TONGCONG",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "NGOAIDS",
    isResizable: true,
    dataIndex: "t_NGOAIDS",
    key: "t_NGOAIDS",
    show: true,
    align: "center",
  },
  {
    title: "Mã khoa",
    isResizable: true,
    dataIndex: "ma_KHOA",
    key: "ma_KHOA",
    show: true,
    align: "center",
  },
  {
    title: "Năm QT",
    isResizable: true,
    dataIndex: "nam_QT",
    key: "nam_QT",
    show: true,
    align: "center",
  },
  {
    title: "Tháng QT",
    isResizable: true,
    dataIndex: "thang_QT",
    key: "thang_QT",
    show: true,
    align: "center",
  },
  {
    title: "Mã khu vực",
    isResizable: true,
    dataIndex: "ma_KHUVUC",
    key: "ma_KHUVUC",
    show: true,
    align: "center",
  },
  {
    title: "Mã loại KCB",
    isResizable: true,
    dataIndex: "ma_LOAI_KCB",
    key: "ma_LOAI_KCB",
    show: true,
    align: "center",
    render: (value, record, index) => {
      if (value === "1") {
        return "Khám bệnh";
      } else if (value === "2") {
        return "Điều trị ngoại trú";
      } else if (value === "3") {
        return "Điều trị nội trú";
      } else {
        return value;
      }
    },
  },
  {
    title: "Mã CSKCB",
    isResizable: true,
    dataIndex: "ma_CSKCB",
    key: "ma_CSKCB",
    show: true,
    align: "center",
  },
  {
    title: "Tổng tiền nguồn khác",
    isResizable: true,
    dataIndex: "t_NGUONKHAC",
    key: "t_NGUONKHAC",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
];
const columns5: ColumnProps[] = [
  {
    title: "STT",
    isResizable: true,
    dataIndex: "stt",
    key: "stt",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    width: "3%",
    align: "center",
    // fixed: "left"
  },
  {
    title: "Mã DVKT",
    isResizable: true,
    dataIndex: "ma_DVKT",
    key: "ma_DVKT",
    show: true,
    align: "center",
  },
  {
    title: "Tên DVKT",
    isResizable: true,
    dataIndex: "ten_DVKT",
    key: "ten_DVKT",
    show: true,
    align: "left",
  },
  {
    title: "Từ ngày",
    isResizable: true,
    dataIndex: "tuNgay",
    key: "ten_THUONG_MAI",
    show: true,
    align: "center",
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY");
      } else {
        return value; // hoặc bạn có thể trả về một chuỗi rỗng hoặc giá trị khác tùy thuộc vào trường hợp sử dụng của bạn
      }
    },
  },
  {
    title: "Đến ngày",
    isResizable: true,
    dataIndex: "denNgay",
    key: "denNgay",
    show: true,
    align: "center",
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY");
      } else {
        return value; // hoặc bạn có thể trả về một chuỗi rỗng hoặc giá trị khác tùy thuộc vào trường hợp sử dụng của bạn
      }
    },
  },
  {
    title: "Đơn giá",
    isResizable: true,
    dataIndex: "don_GIA",
    key: "don_GIA",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "SL nội trú",
    isResizable: true,
    dataIndex: "sl_NOI_TRU",
    key: "sl_NOI_TRU",
    show: true,
    align: "right",
  },
  {
    title: "SL ngoại trú",
    isResizable: true,
    dataIndex: "sl_NGOAI_TRU",
    key: "sl_NGOAI_TRU",
    show: true,
    align: "right",
  },
  {
    title: "Tỉ lệ thanh toán",
    isResizable: true,
    dataIndex: "ty_LE_TT",
    key: "ty_LE_TT",
    show: true,
    align: "right",
  },
  {
    title: "Giá thanh toán",
    isResizable: true,
    dataIndex: "gia_THANHTOAN",
    key: "gia_THANHTOAN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Thành tiền",
    isResizable: true,
    dataIndex: "thanh_TIEN",
    key: "thanh_TIEN",
    show: true,
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
];
export { field, columns1, columns2, columns3, columns4, columns5, field2 };
